import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { Button, ButtonToolbar } from "react-bootstrap";
import { useDrop } from "react-dnd";
import FontAwesome from "react-fontawesome";

import CrewCapacities from "../shared/CrewCapacities";
import CrewName from "../shared/CrewName";
import Event from "../shared/Event";
import styles from "./DayView.less";
import { isNumber } from "lodash";

const Crew = ({
  active,
  crew,
  date,
  events,
  onCrewSelect,
  onEditCrewClick,
  onPrintWorkOrder,
  onReschedule,
  onScheduleBid,
  onScheduleDelivery,
  onScheduleJob,
  onSheeduleAppointment,
  updateSettings,
}) => {
  const [{ canDrop, isDragging, isOver }, drop] = useDrop({
    accept: ["bid", "event", "job", "purchaseOrder", "appointment"],
    canDrop: (item) => {
      switch (item.type) {
        case "bid":
          // Bids cannot be scheduled to a crew
          return !crew;
        case "event":
          const { event } = item;
          if (event.bid) {
            // Bids cannot be scheduled to a crew
            return !crew;
          } else {
            return (
              !crew ||
              !event.office ||
              crew.offices.some((o) => o.id === event.office.id)
            );
          }
        case "job":
          // Job office must match crew's office
          const { job } = item;
          return (
            !crew ||
            !job.office ||
            crew.offices.some((o) => o.id === job.office.id)
          );
        case "purchaseOrder":
          // Purchase order office must match crew's office
          const { purchaseOrder } = item;
          return (
            !crew ||
            !purchaseOrder.office ||
            crew.offices.some((o) => o.id === purchaseOrder.office.id)
          );
        case "appointment":
          return true;
        default:
          break;
      }
      return true;
    },
    collect: (monitor) => ({
      canDrop: !!monitor.canDrop(),
      isDragging: !!monitor.getItem(),
      isOver: !!monitor.isOver(),
    }),
    drop(item) {
      switch (item.type) {
        case "bid":
          const { bidId } = item;
          onScheduleBid && onScheduleBid(bidId, date.format("YYYY-MM-DD"));
          break;
        case "event":
          const { eventId } = item;
          onReschedule &&
            onReschedule(eventId, date.format("YYYY-MM-DD"), crew, "day");
          break;
        case "job":
          const { jobId } = item;
          onScheduleJob &&
            onScheduleJob(jobId, crew, date.format("YYYY-MM-DD"), "day");
          break;
        case "purchaseOrder":
          const { purchaseOrderId } = item;
          onScheduleDelivery &&
            onScheduleDelivery(
              purchaseOrderId,
              date.format("YYYY-MM-DD"),
              crew
            );
          break;

        case "appointment":
          var datasheetid = null;
          var customerid = null;
          var appointmenttype = null;
          if (item.appointment.eventtype === "datasheet")
            datasheetid = item.appointment.id;
          if (item.appointment.eventtype === "customer")
            customerid = item.appointment.id;
          onSheeduleAppointment(
            datasheetid,
            customerid,
            appointmenttype,
            crew,
            date.format("YYYY-MM-DD"),
            null,
            date.format("YYYY-MM-DD"),
            null,
            "",
            "day"
          );
          updateSettings({
            entity: "appointments",
            schedulerView: "equipment",
          });
          break;
        default:
          break;
      }
    },
  });

  return (
    <div
      className={classNames("panel", {
        "panel-primary": active || (canDrop && isOver),
        "panel-default": !active && !(canDrop && isOver),
        [styles.disabled]: isDragging && !canDrop,
      })}
      ref={drop}
    >
      <div className="panel-heading" onClick={() => onCrewSelect(crew)}>
        <CrewName crew={crew} />
      </div>
      <div className="panel-body">
        <CrewCapacities crew={crew} events={events} />
        <ButtonToolbar>
          {onEditCrewClick && (
            <Button onClick={onEditCrewClick}>
              <FontAwesome name="pencil" /> Edit Crew
            </Button>
          )}
          {onPrintWorkOrder && (
            <Button
              disabled={
                !events.some((e) => e.job) ||
                events.some((e) => e.job && !isNumber(e.id))
              }
              onClick={() =>
                onPrintWorkOrder({
                  eventId: events.filter((e) => e.job).map((e) => e.id),
                  date: date.format("YYYY-MM-DD"),
                })
              }
            >
              <FontAwesome name="print" /> Print Work Orders
            </Button>
          )}
        </ButtonToolbar>
        <hr />
        {events.length ? (
          events.map((e) => (
            <Event eventId={e.id} event={e} key={e.id} showBorderLeft={true} />
          ))
        ) : (
          <blockquote>No jobs are scheduled for this crew</blockquote>
        )}
      </div>
    </div>
  );
};

Crew.propTypes = {
  active: PropTypes.bool.isRequired,
  crew: PropTypes.object,
  events: PropTypes.arrayOf(PropTypes.object).isRequired,
  onCrewSelect: PropTypes.func.isRequired,
  onEditCrewClick: PropTypes.func,
  onReschedule: PropTypes.func,
  onPrintWorkOrder: PropTypes.func,
  onScheduleDelivery: PropTypes.func,
  onScheduleJob: PropTypes.func,
};

export default Crew;
